<!-- This is a preview version of what the real version should be. We simply return the lowest price available with the specs -->
<template>
    <section class="call-to-action featured featured-primary" id="offer">
        <div class="col" style="padding: 0">
            <div class="call-to-action-content" style="text-align: left; width: 100%; padding: 0">
                <div class="row">
                    <div class="col">
                        <div class="row">
                            <!--  col-md-8 -->
                            <div class="col-12">
                                <h4>{{ $t('components.prices.static.details') }}</h4>
                                <p>
                                    {{ $t('components.prices.static.checkin') }}: {{ startDate | dateFormat }} ({{ $t('components.prices.static.checkInRule') }} 14:00 - 16:00)<br>
                                    {{ $t('components.prices.static.checkout') }}: {{ endDate | dateFormat }} ({{ $t('components.prices.static.checkOutRule') }} 09:00 - 11:00)<br>
                                    {{ $t('components.prices.static.occupants') }}: {{ computeStepTwoTitle }}
                                </p>
                            </div>
                            <!-- <div class="col-12 col-md-4 text-right">
                                <h4>{{ $t('components.prices.common.price') }}</h4>
                                <h2 style="margin-bottom: 0"><span style="font-size: 18px">{{ $t('common.generic.from') }} CHF</span><span style="margin-left: 5px; font-size: 42px">{{ price.total }}</span></h2>
                                <p style="color: grey; font-size: 14px">{{price.perNight }}.- / {{ $t('components.prices.common.night') }}</p>
                            </div> -->
                        </div>
                        <div class="row">
                            <div class="col">
                                <slot></slot>
                            </div>
                        </div>
                    </div>

                    
                </div>

                 
                <template v-if="showListing"> 
                    <hr class="solid">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <div class="col-12">
                                    <h4>{{ $t('common.keywords.listing') }}</h4>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-3">
                                    <img width="100%" :src="`${this.STATIC_ASSETS_URL}/${listing.images[0].filename}`">
                                </div>
                                <div class="col-12 col-md-9">
                                    <h5 class="card-title">{{ listing.localizedName | localized }}</h5>
                                    <p class="locationParagraph"><i class="fas fa-map-marker-alt location"></i>  {{ computeLocation }}</p>
                                    <p class="card-text">{{ listing.localizedDescription | localized }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </section>
</template>


<script>
import Spinner from "@/components/common/Spinner"
export default {
    name: 'StaticPriceResult',
    components: {
        Spinner
    },
    props: {
        startDate: {
            type: Date,
            required: false
        },
        endDate: {
            type: Date,
            required: false
        },
        adults: {
            type: Number,
            required: false,
        },
        kids: {
            type: Number,
            required: false,
        },
        listing: {
            type: Object,
            required: false
        },
        showListing: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        computeText: function(value, str) {
            if (value == 0) {
                return "";
            }

            return value + " " + str
        },
        findLowestPrice: function() {
            // We first find the lowest price
            let smallestPrice = this.listing.prices[0];
            for (let i = 0; i < this.listing.prices.length; i++) {
                if (this.listing.prices[i].pricePerDay <= smallestPrice.pricePerDay) {
                    smallestPrice = this.listing.prices[i];
                }
            }
            return smallestPrice;
        }
    },
    computed: {
        computeStepTwoTitle: function() {
            return [
                this.computeText(this.adults, this.$i18n.tc('common.generic.adult', this.adults)),
                this.computeText(this.kids, this.$i18n.tc('common.generic.kid', this.kids))
            ].filter(val => val !== "").join(", ");
        },
        computeLocation: function() {
            if (this.isUndefined(this.listing) || this.isUndefined(this.listing.address)) {
                return "UNKNOWN";
            }

            return this.listing.address.city;
            // return this.listing.address.street + ", " + this.listing.address.number + " - " + this.listing.address.cap + " " + this.listing.address.city
        },
        price: function() {
            if (this.isUndefined(this.startDate) || this.isUndefined(this.endDate)) {
                return {
                    total: 0,
                    perNight: 0
                };
            }

            let lowestPrice = this.findLowestPrice();

            const diffTime = Math.abs(this.endDate - this.startDate);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 

            let price =  {
                total: lowestPrice.pricePerDay * diffDays,
                perNight: lowestPrice.pricePerDay
            }

            return price;
        }
    }
}
</script>

<style lang="scss" scoped>    
    .call-to-action {
        border-top-color: $primary-color !important;
    }

    #offer {
        padding-left: 20px;
        padding-right: 20px;
    }

    // We need to override the color here...
    .btn-success {
        background-color: rgb(40, 167, 69) !important;
        word-wrap: break-word;       
        white-space: normal; 
        text-align: center;
        padding: 10px;
        max-width: 100%; 
        box-sizing: border-box;
    }
</style>